import {
    StyledTextInput,
    StyledFormArea,
    StyledFormButton,
    StyledLabel,
    Avatar,
    StyledTitle,
    colors,
    ButtonGroup,
    ExtraText,
    TextLink,
    CopyrightText
} from './../components/Styles';

import Logo from './../assets/logo.png';

import {Formik, Form} from 'formik';
import {TextInput} from './../components/FormLib';
import * as Yup from 'yup';
import {ThreeDots, MutatingDots} from 'react-loader-spinner';

import {FiMail, FiLock} from 'react-icons/fi';

//auth and redux
import {connect} from 'react-redux';
import {loginUser} from './../auth/actions/userActions';
import {useNavigate} from 'react-router-dom';

const Login = ({loginUser}) => {
    const navigate = useNavigate();
    return (
        <div>
            <StyledFormArea>
                <Avatar image={Logo} />
                <StyledTitle color={colors.theme} size={30}>
                    Player Login
                </StyledTitle>
                <Formik
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    validationSchema={
                        Yup.object({
                            email: Yup.string().email("Invalid email address").required("Required"),
                            password: Yup.string().min(8, "Password is too short").max(30, "Password is too long").required("Required")
                        })
                    }
                    onSubmit={(values, {setSubmitting, setFieldError}) => {
                        console.log(values);
                        loginUser(values, navigate, setFieldError, setSubmitting);
                    }}
                >
                    {({isSubmitting}) => (
                        <Form>
                            <TextInput 
                                name="email"
                                type="text"
                                label="Email Address"
                                placeholder="example@example.com"
                                icon={<FiMail />}
                            />

                            <TextInput 
                                name="password"
                                type="password"
                                label="Password"
                                placeholder="*****"
                                icon={<FiLock />}
                            />
                            <ButtonGroup>
                                {!isSubmitting && <StyledFormButton type="submit">Login</StyledFormButton>}


                                {isSubmitting && (
                                    <MutatingDots
                                        color={colors.theme}
                                        height={100}
                                        width={100}
                                    />
                                )}
                            </ButtonGroup>
                        </Form>
                    )
                    }
                </Formik>
                <ExtraText>
                    New here? <TextLink to='/signup'>Signup</TextLink>
                </ExtraText>
            </StyledFormArea>
            <CopyrightText>
                All rights reserved &copy;2022
            </CopyrightText>
        </div>
    )
}

export default connect(null, {loginUser})(Login);